module.exports = __webpack_public_path__ + "img/dingzhi.263e729c.png";